(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('productWorkflowFactory', productWorkflowFactory);

    productWorkflowFactory.$inject = ['productWorkflow'];

    function productWorkflowFactory(productWorkflow) {
        return {
            create: create
        };

        // -------------------------------------------------------------------------------------

        function create(product) {
            return new productWorkflow.Instance(product);
        }
    }
}());